module.exports = __webpack_public_path__ + "img/soup.e9cb8188.svg";